<template>
  <div class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-30" v-if="isOpen">
    <div class="absolute w-full h-full bg-gray-900 opacity-50"></div>

    <div
      class="absolute max-h-full w-full bottom-0 sm:inset-y-auto overflow-x-hidden overflow-y-auto sm:h-auto sm:max-w-xl"
    >
      <div class="h-fit sm:rounded-21px" style="background-color: #f6f6f6">
        <div class="flex flex-col gap-4 p-4">
          <p class="font-semibold text-lg">Rating Ticket</p>
          <div
            class="flex items-center justify-between"
            v-for="category in ticket.rating.rating_categories"
            :key="category.id"
          >
            <p class="text-sm font-medium">{{ category.name }}</p>
            <div class="flex items-center gap-1">
              <template v-for="n in 5">
                <IconStar
                  v-if="n <= category.rating"
                  :key="'cat-star-' + category.id + '-' + n"
                  class="w-5 h-5 fill-current"
                />
                <IconStarEmpty
                  v-else
                  :key="'cat-star-empty-' + category.id + '-' + n"
                  class="w-5 h-5 fill-current text-hgray3"
                />
              </template>
            </div>
          </div>
          <!-- Emoji and main star rating -->
          <p class="text-sm font-medium">Nilai Tiket</p>
          <div class="flex flex-col items-center">
            <img
              v-if="ticket.rating.rating >= 1 && ticket.rating.rating <= 5"
              :src="emoticons[ticket.rating.rating - 1]"
              class="mx-auto z-10 relative animate-rating w-14 h-14"
              :key="ticket.rating.rating"
            />
            <!-- <div class="text-center font-Nerko text-hblue mt-1">
              {{ textIcon[ticket.rating.rating - 1] }}
            </div> -->
            <div class="flex items-center gap-1 mt-2">
              <template v-for="n in 5">
                <IconStar
                  v-if="n <= ticket.rating.rating"
                  :key="'main-star-' + n"
                  class="w-7 h-7 fill-current"
                />
                <IconStarEmpty
                  v-else
                  :key="'main-star-empty-' + n"
                  class="w-7 h-7 fill-current text-hgray3"
                />
              </template>
            </div>
          </div>

          <div
            class="py-2 px-3 bg-hgray3"
            style="border: 1px solid #e3e3e3; border-radius: 7px; min-height: 80px"
          >
            <span class="text-xs font-medium">
              {{ ticket.rating.comment }}
            </span>
          </div>
          <button
            class="btn btn-secondary hover:bg-htealdark rounded-full capitalize h-10 sm:justify-self-start hover:border-transparent w-full"
            @click="close"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import IconStar from '@/assets/icons/icon-star.svg?inline'
import IconStarEmpty from '@/assets/icons/icon-star-empty.svg?inline'
import EmoticonOne from '@/assets/icons/emoticon-1star.svg'
import EmoticonTwo from '@/assets/icons/emoticon-2star.svg'
import EmoticonThree from '@/assets/icons/emoticon-3star.svg'
import EmoticonFour from '@/assets/icons/emoticon-4star.svg'
import EmoticonFive from '@/assets/icons/emoticon-5star.svg'

export default {
  name: 'rating-detail',
  data() {
    return {
      emoticons: [EmoticonOne, EmoticonTwo, EmoticonThree, EmoticonFour, EmoticonFive],
      textIcon: ['Disappointed', 'Bad', 'Not Good', 'Good', 'Awesome']
    }
  },
  components: {
    IconStar,
    IconStarEmpty
  },
  methods: {
    ...mapActions('modal', ['MODAL_RATING_DETAIL']),
    close() {
      this.MODAL_RATING_DETAIL(false)
    }
  },
  computed: {
    isOpen: {
      get: function () {
        return this.$store.state.modal.ratingDetail
      },
      set: function (value) {
        this.MODAL_RATING_DETAIL(value)
      }
    },
    ...mapState({
      ticket: state => state.ticket.ticket
    })
  }
}
</script>
